import {IItemContent} from "@connox/typescript-library";
import React, {Suspense, useEffect, useState} from "react";
import ReactDOM from "react-dom";
import {paMainUrl, retrieveItemContent} from "./CrossSelling";
import {useCustomerSelector} from "../../../store";
import {useTranslation} from "react-i18next";
import ErrorBoundary from "../../utils/ErrorBoundary";
import SwiperConstruct from "./SwiperConstruct";
import ListItemCard from "../productList/ListItemCard";

// Ähnliche Produkte entdecken - grid of 4 columns
const SimilarProductsPortalComponent: React.FC<{itemId?: string}> = ({itemId}) => {
  const [items, setItems] = useState<IItemContent[]>([]);
  const {t} = useTranslation();
  const {customer} = useCustomerSelector();

  useEffect(() => {
    if (!itemId) {
      return;
    }
    // https://docs.particularaudience.com/api-definitions/similar-items
    const paUrl = `${paMainUrl}ViewedTogetherVisuallySimilar?productRef=${itemId}&productStyleId=${itemId}&filteroutofstock=true`;
    void retrieveItemContent(paUrl, customer).then(setItems);
  }, []);

  if (!items.length) {
    return null;
  }

  return (
    <SwiperConstruct title={t("product.discoverSimilarProducts")}>
      {items.map((item, key) => (
        <ListItemCard item={item} key={key} />
      ))}
    </SwiperConstruct>
  );
};

const SimilarProductsPortal: React.FC<{itemId?: string}> = ({itemId}) => {
  const parentCategoriesElement = document.getElementById("PASimilarProducts");

  if (!parentCategoriesElement) {
    return null;
  }

  return ReactDOM.createPortal(
    <ErrorBoundary fallback={null} occurrence="SimilarProductsPortal">
      <Suspense fallback={null}>
        <SimilarProductsPortalComponent itemId={itemId} />
      </Suspense>
    </ErrorBoundary>,
    parentCategoriesElement,
  );
};

export default SimilarProductsPortal;
